export const getTwoDigitZerofil = number => {
  return number < 10 ? "0" + number : number
}

export const compareNumbers = (aNumber, bNumber) =>
  parseInt(aNumber) - parseInt(bNumber)
